module.exports = __webpack_public_path__ + "static/media/22.fe663003.svg";